define('bizzabo/routers/AppRouter',['backbone', 'backbone-queryparams', 'underscore', 'bizzabo/config', 'bizzabo/consts'], function(Backbone, BackboneQueryParams, _, CONFIG, Consts) {

    var AppRouter = Backbone.Router.extend({

        routes : {
            "" : "redirectToAccount",

            "event/:eventId/dashboard" : "dashboard",
            "event/:eventId/community" : "redirectToAccount",
            "event/:eventId/partners" : "redirectToAccount",
            "event/:eventId/polls" : "polls",

            "event/:eventId/agenda/session/:cid/:field" : "agenda",
            "event/:eventId/agenda/session/:cid" : "agenda",
            "event/:eventId/agenda/import" : "agendaWithImport",
            "event/:eventId/agenda/errors" : "agendaWithErrorList",
            "event/:eventId/agenda" : "agenda",

            "event/:eventId/sponsors/:type/:cid/:field" : "sponsors",
            "event/:eventId/sponsors/:type/:cid" : "sponsors",
            "event/:eventId/sponsors/:type" : "sponsors",
            "event/:eventId/sponsors" : "sponsors",

            "event/new" : "redirectToAccount",
            "event/newWithPackage/:packageId" : "redirectToAccount",
            "event/new/promote" : "redirectToAccount",
            "event/new/focus/:field" : "redirectToAccount",
            "event/new/*json" : "redirectToAccount",
            "event/:eventId" : "redirectToAccount",
            "event/:eventId/focus/:field" : "redirectToAccount",
            "*path": 'redirectToAccount'
        },

        initialize : function(options) {
            this.delegate = options && options.delegate;
            this.listenTo(Backbone, Consts.Notifications.router.NAVIGATE_REQUEST, this.navigate);
            this.listenTo(Backbone, Consts.Notifications.router.EVENT_ID_CHANGED, this.eventIdChanged);
        },

        redirectToAccount: function() {
            window.location = CONFIG.DASHBOARD_URL;
        },

        agendaWithImport : function(eventId) {
            CONFIG.ALLOW_IMPORT_AGENDA = true;
            this.agenda(eventId);
        },

        agendaWithErrorList : function(eventId) {
            this.delegate.editAgenda(eventId, {
                errors: true
            });
        },

        agenda : function(eventId, cid, field, queryParams) {
            if (_.isObject(eventId)) {
                queryParams = eventId;
                eventId = undefined;
                cid = undefined;
                field = undefined;
            }

            if (eventId == 'new') {
                eventId = undefined;
            }

            this.delegate.applyQueryParams(queryParams);
            this.delegate.editAgenda(eventId, {
                cid : cid,
                field : field
            });
        },

        dashboard : function(eventId, queryParams) {
            if (_.isObject(eventId)) {
                queryParams = eventId;
                eventId = undefined;
            }

            if (eventId == 'new') {
                eventId = undefined;
            }

            this.delegate.applyQueryParams(queryParams);
            this.delegate.dashboard(eventId);
        },




        sponsors : function(eventId, type, cid, field, queryParams) {
            if (_.isObject(eventId)) {
                queryParams = eventId;
                eventId = undefined;
                type = undefined;
                cid = undefined;
                field = undefined;
            }

            if (eventId == 'new') {
                eventId = undefined;
            }

            this.delegate.applyQueryParams(queryParams);
            this.delegate.sponsors(eventId, {
                type : type,
                cid : cid,
                field : field
            });
        },

        polls : function(eventId, queryParams) {
            if (eventId == 'new') {
                eventId = undefined;
            }

            this.delegate.applyQueryParams(queryParams);
            this.delegate.polls(eventId);
        },

        community : function(eventId, queryParams) {
            if (_.isObject(eventId)) {
                queryParams = eventId;
                eventId = undefined;
            }

            if (eventId == 'new') {
                eventId = undefined;
            }

            this.delegate.applyQueryParams(queryParams);
            this.delegate.community(eventId);
        },

        growWidgets : function(eventId, queryParams) {
            this.growLoad(eventId, 'widgets', queryParams);
        },

        growMinisite : function(eventId, queryParams) {
            this.growLoad(eventId, 'minisite', queryParams);
        },

        growPrints : function(eventId, queryParams) {
            this.growLoad(eventId, 'prints', queryParams);
        },

        partners : function(eventId, queryParams) {
            if (_.isObject(eventId)) {
                queryParams = eventId;
                eventId = undefined;
            }

            if (eventId == 'new') {
                eventId = undefined;
            }

            this.delegate.applyQueryParams(queryParams);
            this.delegate.partners(eventId);
        },

        eventIdChanged : function(eventId) {
            var urlSuffix = window.location.hash;
            var newUrl = urlSuffix.replace("new", eventId);
            CONFIG.DEBUG && console.log("AppRouter changed event id! Rerouted: " + urlSuffix + " to " + newUrl);
            Backbone.trigger(Consts.Notifications.router.NAVIGATE_REQUEST, newUrl, {
                trigger : false
            });
        }
    });

    return AppRouter;

});
